import React from 'react';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-green-950 text-white pt-16 pb-8 border-t border-green-900" data-id="element-179">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-180">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-181">
          {/* Brand Column */}
          <div data-id="element-182">
            <h3 className="text-2xl font-bold text-white mb-6" data-id="element-183">
              GreenSlopes<span className="text-green-400" data-id="element-184">Farm</span>
            </h3>
            <p className="text-green-200/80 mb-6 leading-relaxed" data-id="element-185">
              A legacy of agricultural excellence in Nyandarua County. Dedicated
              to sustainable dairy farming and community growth since 1960.
            </p>
            <div className="flex space-x-4" data-id="element-186">
              <a href="#" className="p-2 bg-green-900 rounded-full hover:bg-green-800 transition-colors text-green-300 hover:text-white" data-id="element-187">
                <Facebook className="h-5 w-5" data-id="element-188" />
              </a>
              <a href="#" className="p-2 bg-green-900 rounded-full hover:bg-green-800 transition-colors text-green-300 hover:text-white" data-id="element-189">
                <Instagram className="h-5 w-5" data-id="element-190" />
              </a>
              <a href="#" className="p-2 bg-green-900 rounded-full hover:bg-green-800 transition-colors text-green-300 hover:text-white" data-id="element-191">
                <Twitter className="h-5 w-5" data-id="element-192" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-193">
            <h4 className="text-lg font-semibold text-white mb-6" data-id="element-194">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-195">
              <li data-id="element-196">
                <a href="#home" className="text-green-200/80 hover:text-white transition-colors" data-id="element-197">
                  Home
                </a>
              </li>
              <li data-id="element-198">
                <a href="#story" className="text-green-200/80 hover:text-white transition-colors" data-id="element-199">
                  Our Story
                </a>
              </li>
              <li data-id="element-200">
                <a href="#dairy" className="text-green-200/80 hover:text-white transition-colors" data-id="element-201">
                  Dairy Farming
                </a>
              </li>
              <li data-id="element-202">
                <a href="#visits" className="text-green-200/80 hover:text-white transition-colors" data-id="element-203">
                  Farm Visits
                </a>
              </li>
              <li data-id="element-204">
                <a href="#partner" className="text-green-200/80 hover:text-white transition-colors" data-id="element-205">
                  Partner With Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-206">
            <h4 className="text-lg font-semibold text-white mb-6" data-id="element-207">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-208">
              <li className="flex items-start" data-id="element-209">
                <MapPin className="h-5 w-5 text-green-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-210" />
                <span className="text-green-200/80" data-id="element-211">
                  Nyandarua County, Kenya
                </span>
              </li>
              <li className="flex items-center" data-id="element-212">
                <Phone className="h-5 w-5 text-green-400 mr-3 flex-shrink-0" data-id="element-213" />
                <span className="text-green-200/80" data-id="element-214">+254 720 934332</span>
              </li>
              <li className="flex items-center" data-id="element-215">
                <Mail className="h-5 w-5 text-green-400 mr-3 flex-shrink-0" data-id="element-216" />
                <span className="text-green-200/80" data-id="element-217">
                  info@greenslopesfarm.co.ke
                </span>
              </li>
            </ul>
          </div>

          {/* Newsletter/Hours */}
          <div data-id="element-218">
            <h4 className="text-lg font-semibold text-white mb-6" data-id="element-219">
              Visiting Hours
            </h4>
            <div className="bg-green-900/50 p-6 rounded-lg border border-green-800" data-id="element-220">
              <p className="text-green-200/80 mb-2 flex justify-between" data-id="element-221">
                <span data-id="element-222">Mon - Fri:</span>
                <span className="text-white" data-id="element-223">8:00 AM - 5:00 PM</span>
              </p>
              <p className="text-green-200/80 mb-4 flex justify-between" data-id="element-224">
                <span data-id="element-225">Sat:</span>
                <span className="text-white" data-id="element-226">9:00 AM - 1:00 PM</span>
              </p>
              <p className="text-sm text-green-400 italic" data-id="element-227">
                *Visits by appointment only
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-green-900 pt-8 text-center text-green-200/60 text-sm" data-id="element-228">
          <p data-id="element-229">&copy; {currentYear} GreenSlopes Farm. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}